import React from 'react';
import PropTypes from 'prop-types';

import { FormEvents, FormEventHandler } from '../../events/form_event_handler';
import { FormAPI } from 'lecom-api';

import { Button } from 'realize/components/button';

export default class SingleActionButton extends React.Component {
	static propTypes = {
		id: PropTypes.string,
		formId: PropTypes.number,
		parentFieldId: PropTypes.string,
		gridFormParent: PropTypes.string,
		disabled: PropTypes.bool,
		confirmsWith: PropTypes.string,
	};

	static defaultProps = {
		disabled: false,
		confirmsWith: null
	};

	constructor(props) {
		super(props);
		this.executeAction = this.executeAction.bind(this);
	}

	getActionAPI() {
		const formAPI = FormAPI.form(this.props.formId);
		return (this.props.parentFieldId)
			? this.getFieldAPI(formAPI).actions(this.props.id)
			: formAPI.actions(this.props.id);
	}

	getFieldAPI(formAPI) {
		return (this.props.gridFormParent)
			? formAPI.fields(this.props.gridFormParent).fields(this.props.parentFieldId)
			: formAPI.fields(this.props.parentFieldId);
	}

	executeAction() {
		const actionAPI = this.getActionAPI();
		FormEventHandler.publish(FormEvents.CLICK, actionAPI.storeId, this.getActionName());
		if(this.confirmAction() && actionAPI && typeof actionAPI.execute === 'function') {
			actionAPI.execute();
		}
	}

	confirmAction() {
		let confirmsWith = this.props.confirmsWith;
		return !confirmsWith || window.confirm(confirmsWith);
	}

	getActionName() {
		return (this.props.id || this.props.name);
	}

	getActionButtonComponent() {
		let actionComponent = this.props.component;
		if(typeof actionComponent == "string") {
			return window[actionComponent];
		} else if(typeof actionComponent == "function") {
			return actionComponent;
		}

		return Button;
	}

	getActionButtonName() {
		return this.props.label || this.props.name;
	}

	render() {
		const Component = this.getActionButtonComponent();
		return (
			<Component
			{...this.props}
			name={this.getActionButtonName()}
			onClick={this.executeAction}
			/>
		);
	}
}
